import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { MESSAGE_REPOSITORY } from '../../core';
import { MESSAGE_API } from '../data-sources';
import { customMappingResultError } from '@lib/domain-common';
export var MessageWebRepository = /*#__PURE__*/function () {
  function MessageWebRepository(messageApi) {
    _classCallCheck(this, MessageWebRepository);

    this.messageApi = messageApi;
  }

  _createClass(MessageWebRepository, [{
    key: "getMessages",
    value: function () {
      var _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError, paginationResponse, sortedItems;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.messageApi.getMessages(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                paginationResponse = responseOrError.getValue(); // Sort messages by created at ascending order

                sortedItems = paginationResponse.items.sort(function (a, b) {
                  return a.createdTime.value.getTime() - b.createdTime.value.getTime();
                }); // Update items in pagination response

                paginationResponse.updateItems(sortedItems);
                return _context.abrupt("return", Result.ok(paginationResponse));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMessages(_x) {
        return _getMessages.apply(this, arguments);
      }

      return getMessages;
    }()
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, dto;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.messageApi.sendMessage(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", customMappingResultError(responseOrError));

              case 5:
                dto = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok({
                  id: dto.id
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendMessage(_x2) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
  }, {
    key: "stopMessage",
    value: function () {
      var _stopMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(conversationId, messageId) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.messageApi.stopMessage(conversationId, messageId);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function stopMessage(_x3, _x4) {
        return _stopMessage.apply(this, arguments);
      }

      return stopMessage;
    }()
  }]);

  return MessageWebRepository;
}();
export var messageWebRepositoryProvider = {
  provide: MESSAGE_REPOSITORY,
  useFactory: function useFactory(messageApi) {
    return new MessageWebRepository(messageApi);
  },
  inject: [MESSAGE_API]
};